import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { transitions } from '@prisma/animations/animations';
import { of } from 'rxjs';
import { ToolbarActionItemModel } from './ian-action-toolbar.model';

@Component({
  selector: 'ian-action-toolbar',
  templateUrl: './ian-action-toolbar.component.html',
  styleUrls: ['./ian-action-toolbar.component.scss'],
  animations: [transitions],
})
export class ActionToolbarComponent implements OnInit {
  @Input() totalItemsSelected: number;
  @Input() disabled: boolean;

  // actionsCondig contiene los botones que hay que mostrar
  @Input() actions: Array<ToolbarActionItemModel>;

  @Output() clearSelected: EventEmitter<void> = new EventEmitter();

  // actionExecuted emite accion a ejecutar
  @Output() actionExecuted: EventEmitter<ToolbarActionItemModel> = new EventEmitter();

  ngOnInit(): void {}

  isBoolean(obj) {
    return typeof obj === 'boolean';
  }

  emitClearSelection(): void {
    this.clearSelected.emit();
  }

  emitActionExecution(action): void {
    this.actionExecuted.emit(action);
  }
}
